/*@flow*/
import createStore from './createStore';
import withMutation from 'store/withMutation';
import reducer from './reducer';
import * as I from 'immutable';

// ---------------------------
const initState = I.Map({
  $query: I.Map(),
  ui: I.Map({
    toaster: I.Map({
      type: 'Closed', // Open, Closed, OpenAreaLink
      duration: 10000,
    }),
  }),
  profile: I.Map(), // Map<*, *>
  projects: I.Map({
    numProjects: 0,
  }),
  basemaps: I.Map({}),
  modeMapLabelsEnabled: false,
});

// storeCreator is a wrapper around createStore factory.
export const storeCreator = (s: I.Map<string, *> = initState) => {
  const mutableReducer = withMutation(reducer);
  return createStore<*, *, *>(mutableReducer, s);
};

// Exports default store
export default storeCreator();
